import {ThumbsUp, ThumbsDown} from 'lucide-react';
import {Ticket} from '../../types';
import {TicketFeedbackController} from '../../hooks/useTicketFeedback';
import {Btn} from '../Shared';

type FeedbackProps = {ticket: Ticket; disabled: boolean; feedback: TicketFeedbackController};
const ratings = [
  {value: 'up' as const, label: 'Helpful draft', Icon: ThumbsUp},
  {value: 'down' as const, label: 'Needs improvement', Icon: ThumbsDown},
];

export const DraftFeedbackButtons = ({ticket, disabled, feedback}: FeedbackProps) => <div><span>Helpful?</span>
  {ratings.map(({value, label, Icon}) => <button key={value}
    className={`icon-button ${ticket.feedback === value ? 'selected' : ''}`}
    onClick={() => feedback.rate(value)} title={label} aria-label={label}
    data-testid={`draft-feedback-${value}`} disabled={disabled}><Icon size={12}/></button>)}
</div>;

export const DraftFeedbackNote = ({feedback}: {feedback: TicketFeedbackController}) => {
  if (!feedback.noteOpen) return null;
  return <div className="feedback-note">
    <textarea className="field-textarea" data-testid="feedback-note-input" aria-label="Feedback details"
      placeholder="What could be better?" value={feedback.note} onChange={event => feedback.setNote(event.target.value)} maxLength={1000}/>
    <Btn data-testid="feedback-note-save" onClick={feedback.saveNote}>Save feedback</Btn>
  </div>;
};